/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf
 */
export interface BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf
     */
    'cardType': BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOf
     */
    'expiredDate': string;
}

export const BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum = typeof BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum[keyof typeof BulkUpdateDailyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum];


